class CollectionFeatureHighlights extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.toggles = [...this.querySelectorAll('[data-feature-highlight-toggle]')];
    this.panels = [...this.querySelectorAll('[data-feature-highlight-panel]')];

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => this.togglePanel(toggle));
    });
  }

  togglePanel(activeToggle) {
    const shouldOpen = activeToggle.getAttribute('aria-expanded') !== 'true';
    const activePanelId = activeToggle.getAttribute('aria-controls');

    this.dataset.hasOpenPanel = String(shouldOpen);

    this.toggles.forEach((toggle) => {
      const isActive = shouldOpen && toggle === activeToggle;
      toggle.setAttribute('aria-expanded', String(isActive));
      toggle.classList.toggle('is-active', isActive);
    });

    this.panels.forEach((panel) => {
      panel.hidden = !shouldOpen || panel.id !== activePanelId;
    });

    if (shouldOpen) {
      activeToggle.dispatchEvent(new CustomEvent('real:promotion-open', { bubbles: true }));
    }
  }
}

if (!customElements.get('collection-feature-highlights')) {
  customElements.define('collection-feature-highlights', CollectionFeatureHighlights);
}
